import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21056f88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-template" }
const _hoisted_2 = ["src", "width", "height"]
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-text" }

import { computed } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CardTemplate',
  props: {
        image: String,
        title: String,
        text: String,
        width: {
            default: 200,
            type: [Number, String],
        },
    },
  setup(__props) {

const props = __props;

    
    var height = computed(() => Math.max(100, props.width * 0.7));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "wrapper",
      style: _normalizeStyle({ width: __props.width + 'px' })
    }, [
      _createElementVNode("img", {
        class: "img-content",
        src: __props.image,
        width: __props.width,
        height: _unref(height)
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.text), 1)
    ], 4)
  ]))
}
}

})